<a routerLink="/" class="navbar-brand"> <img src="assets/img/logo.png" alt="logo-container_image"></a>
<!-- Menu -->
<ul>
    <!-- Data -->
    <li [ngClass]="item.child ? 'menu-item menu-item-has-children':'menu-item'" *ngFor="let item of navigation">
        <a routerLink="{{item.link}}" *ngIf="item.child" (click)="trigger(item)">{{item.linkText | translate}}</a>
        <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText | translate}}</a>
        <ul class="sub-menu" *ngIf="item.child" [ngClass]="item.open ? 'd-block' : ''">
            <li [ngClass]="item.child ? 'menu-item menu-item-has-children':'menu-item'"
                *ngFor="let item of item.submenu">
                <a routerLink="{{item.link}}" *ngIf="item.child" (click)="trigger(item)">{{item.linkText | translate}}</a>
                <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText | translate}}</a>
                <ul class="sub-menu" *ngIf="item.child" [ngClass]="item.open ? 'd-block' : ''">
                    <li [ngClass]="item.child ? 'menu-item menu-item-has-children':'menu-item'"
                        *ngFor="let item of item.submenu">
                        <a routerLink="{{item.link}}">{{item.linkText | translate}}</a>
                    </li>
                </ul>
            </li>
        </ul>
    </li>
    <li class="menu-item menu-item-has-children">
        <a>{{'language' | translate}}</a>
        <ul class="sub-menu d-block" [ngClass]="open ? 'd-block' : ''">
            <li *ngIf="_translatesService.getCurrentLang() == 'ar'" class="menu-item"> <a (click)="changeLanguage('en')">{{'en' | translate}}</a>  </li>
            <li *ngIf="_translatesService.getCurrentLang() == 'en'" class="menu-item"> <a (click)="changeLanguage('ar')">{{'ar' | translate}}</a>  </li>
        </ul>
    </li>
    <!-- Data -->
</ul>